<template>
    <div class="util-charttitle">
      <strong>{{ title ?? "Pencatatan Terakhir" }}</strong>
      <router-link :to="action" >
        <button>
          <img src="@/assets/img/util-eye.svg" /> <span>Lihat Semua</span>
        </button>
      </router-link>
    </div>
</template>


<script lang="js">
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Prop } from "vue-property-decorator";
@Component({
  components: {
  },
})
export default class UtilitiesTabTitle extends Vue {
  @Prop() title;
  @Prop() action;

}
</script>
